document.addEventListener('DOMContentLoaded', function () {
  var androidStoreUrl = 'https://play.google.com/store/apps/details?id=com.tunagate.app';

  // Android: Intent URL でネイティブEventPageへ。アプリが無いときは fallbackUrl へ
  function buildAndroidIntentUrl(eventPath, fallbackUrl) {
    return 'intent://invitation?rurl=' + encodeURIComponent(eventPath)
      + '#Intent;scheme=tunagate;package=com.tunagate.app'
      + ';S.browser_fallback_url=' + encodeURIComponent(fallbackUrl)
      + ';end';
  }

  // ===== イベント詳細上部のアプリ誘導 CTA（TGW-1445） =====
  var btn = document.getElementById('js-app-open-or-download');
  if (btn) {
    var isIOS      = btn.dataset.ua === 'ios';
    var isAndroid  = btn.dataset.ua === 'android';
    var isMobile   = isIOS || isAndroid;
    var isSignedIn = btn.dataset.signedIn === '1';

    var scrollToParticipate = function () {
      var pc = document.getElementById('participate-button2');
      var sp = document.getElementById('participate-button');
      var target = (pc && pc.offsetParent !== null) ? pc : sp;
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    btn.addEventListener('click', function () {
      if (!isMobile) {
        if (isSignedIn) {
          $('#appDownloadQrModal').modal('show');
        } else {
          scrollToParticipate();
        }
        return;
      }

      if (isIOS) {
        if (!isSignedIn) { scrollToParticipate(); return; }
        window.location.href = btn.dataset.universalLinkUrl;
        return;
      }

      // フォールバック先は現在のオリジンを使う（本番ホスト固定だと dev/staging から
      // 本番へ飛び、存在しないイベントで 404 → 本番トップへ流されてしまう）
      var androidFallbackUrl = isSignedIn
        ? androidStoreUrl
        : window.location.origin + btn.dataset.eventPath + '#participate-button';
      window.location.href = buildAndroidIntentUrl(btn.dataset.eventPath, androidFallbackUrl);
    });
  }

  // ===== チケット欄・Web 申込画面の「アプリで申し込む」（TGW-2954） =====
  // アカウントを持つ人向けなので、未ログインでもスクロールではなくアプリを開く。
  // チケット欄はプランごと・PC/SP/モーダルに複数あるため、クリックを document で受ける。
  // iOS は a の href（ユニバーサルリンク）のまま進ませる。
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('.js-app-signup-link') : null;
    if (!link) return;

    var ua = link.dataset.ua;
    if (ua === 'android') {
      e.preventDefault();
      window.location.href = buildAndroidIntentUrl(link.dataset.eventPath, androidStoreUrl);
      return;
    }
    if (ua !== 'ios' && document.getElementById('appDownloadQrModal') && window.$) {
      // PC: イベント詳細には QR モーダルがある。無いページ（Web 申込画面）は href へ進む
      e.preventDefault();
      var showQr = function () { $('#appDownloadQrModal').modal('show'); };
      // 下部の #fixedButtonModal の中から押されたとき、重ねて開くと QR を閉じた時点で Bootstrap が
      // body.modal-open を外し、下のモーダルが出たまま背景のスクロール固定が解ける。先に閉じてから開く
      var openModal = link.closest('.modal.show');
      if (openModal) {
        $(openModal).one('hidden.bs.modal', showQr).modal('hide');
      } else {
        showQr();
      }
    }
  });
});
